import { NanodegreeProgram } from '../models/program';

export function getPartTitleFromNanodegree(program: NanodegreeProgram, courseKey: string) {
  for (const part of program.parts) {
    if (part.key === courseKey) {
      return part.title;
    }
  }
}
